import { mapType } from '../types';

const getCity = (mapType?: mapType) => {
	return import(
  	/* webpackChunkName: "map_common" */
		'./getCityAsync'
	).then((defaultModule) => defaultModule.default?.(mapType));
}

export default getCity